<div class="instructions-card">
  <h2>{{ description.title | translate }}</h2>
  @for (step of description.steps; track $index; let i = $index) {
  <div class="instruction-step">
    <div class="step-icon">
      <i class="fas fa-upload"></i>
    </div>
    <div class="step-content">
      <div class="step-number">{{ i + 1 }}</div>
      <div class="step-description" [innerHTML]="step | translate"></div>
    </div>
  </div>
  }
</div>
